export default __webpack_public_path__ + "static/media/feature_5@3x.88e30b96.png";